var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#5C8FDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.768 8.938c.74 0 1.267-.546 1.267-1.249 0-.662-.546-1.189-1.268-1.189-.721 0-1.267.546-1.267 1.229 0 .682.546 1.208 1.268 1.208zm-.937 12.324h1.873V10.927H12.83v10.335z",
    fill: "#fff"
  })));
}
export default SvgInfo;